// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1yPNd","content":"RecentSearches_content__2Nxv6"};